import React, { useRef } from 'react';
import { mergeProps, useFocusRing, useOption } from 'react-aria';
import { MenuListItem } from 'components/MenuList';
import { ListBoxData } from '../types';
import { ListBoxOptionProps } from './types';

function ListBoxOption<T extends ListBoxData = ListBoxData>({
  item,
  state,
}: ListBoxOptionProps<T>): React.ReactElement | null {
  const ref = useRef<HTMLLIElement>(null);

  const { optionProps } = useOption({ key: item.key }, state, ref);
  const { isFocusVisible, focusProps } = useFocusRing();

  return (
    <MenuListItem
      {...mergeProps(optionProps, focusProps)}
      icon={item.props?.icon}
      isFocused={isFocusVisible}
      ref={ref}
    >
      {item.rendered}
    </MenuListItem>
  );
}

export default ListBoxOption;
